import axios from "axios";
import {
    Configuration, ContactUsDto,
    CreateContactUsDto,
    CreateRequestDemoDto,
    MarketingControllerApi,
    RequestDemoDto
} from "@/marketing-api-client";

export class MarketingService extends Error {
    basePath: string;
    token: string
    marketingApi: MarketingControllerApi;

    constructor(basePath: string, token: string) {
        super();
        this.basePath = basePath;
        this.token = token;

        const axiosInstance = axios.create({
            baseURL: basePath,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        });

        const config = new Configuration({
            basePath: basePath,
        });

        this.marketingApi = new MarketingControllerApi(config, basePath, axiosInstance);
    }

    async requestDemo(createRequestDemoDto: CreateRequestDemoDto): Promise<RequestDemoDto> {
        const response = await this.marketingApi.requestDemo(createRequestDemoDto);
        const pageResponse: RequestDemoDto = response.data;
        return pageResponse;
    }

    async createContactUs(createContactUsDto: CreateContactUsDto): Promise<ContactUsDto> {
        const response = await this.marketingApi.createContactUs(createContactUsDto);
        const pageResponse: ContactUsDto = response.data;
        return pageResponse;
    }


}
